<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { generateId } from '@client/utils/generate-id';

  export let row = {};
  export let bordered = false;
  const id = generateId();

  $: border = bordered ? '' : 'border: 0; color: rgba(0,0,0,.4)';
</script>

<div class="bricks-container">
  {#if row.tags.length}
    <div class="bricks">
      {#each row.tags.slice(0, 3) as tag}
        <div class="brick" style="background: {tag.backgroundColor}; {border}">{tag.text}</div>
      {/each}
      {#if row.tags.length > 3}
        <div class="brick more" id="tooltip-{id}-{row.rulename}-tags">
          +{row.tags.length - 3}&nbsp;{$format('label.MORE').toLowerCase()}
        </div>

        <Tooltip target="tooltip-{id}-{row.rulename}-tags">
          {@html row.tags
            .slice(3)
            .map(({ text }) => text)
            .join('<br />')}
        </Tooltip>
      {/if}
    </div>
  {:else}
    <div class="none">{$format('label.NO_ASSIGNED_TAGS')}</div>
  {/if}
</div>

<style lang="scss">
  .bricks-container {
    .bricks {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      position: relative;

      .brick {
        align-items: center;
        background-color: var(--color-white);
        border: 1px solid var(--border-color);
        border-radius: var(--border-radius-base);
        display: flex;
        font-size: var(--font-size-small);
        gap: 4px;
        padding: var(--padding-small) var(--padding-base);

        &.more {
          cursor: help;
        }
      }
    }

    .none {
      color: var(--color-gray-500);
      font-size: var(--font-size-medium);
    }
  }
</style>
